import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Modal from '../ui/Modal';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { setContentMasterSubscriptionInsufficientModalVisible } from '../../store/slices/contentMasterSlice';

const CONTENT_MASTER_BUY_PATH = '/licenses/buy?plugin=content_master';

/**
 * Upgrade modal shown when Content Master generate / bulk endpoints reject the
 * request with `errorCode === 'content_master_subscription_insufficient'`.
 */
const ContentMasterSubscriptionInsufficientModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const visible = useAppSelector(
    (state) => state.contentMaster.subscriptionInsufficientModalVisible
  );

  const close = () => dispatch(setContentMasterSubscriptionInsufficientModalVisible(false));

  return (
    <Modal
      isOpen={visible}
      onClose={close}
      title={t('cm_entitlements_upgrade_modal_title')}
      isCentered
      hideCloseButton
      className="content-master-confirm-modal content-master-confirm-modal--subscription"
    >
      <div className="content-master-confirm-modal__layout">
        <div className="content-master-confirm-modal__text">
          <p>{t('cm_entitlements_upgrade_modal_body')}</p>
        </div>
        <div className="content-master-confirm-modal__illustration" aria-hidden />
      </div>
      <div className="content-master-confirm-modal__buttons">
        <button
          type="button"
          className="btn btn-secondary content-master-confirm-modal__btn-secondary"
          onClick={close}
        >
          {t('cancelText')}
        </button>
        <button
          type="button"
          className="btn btn-primary content-master-confirm-modal__btn-primary"
          onClick={() => {
            close();
            navigate(CONTENT_MASTER_BUY_PATH);
          }}
        >
          {t('cm_entitlements_upgrade_cta')}
        </button>
      </div>
    </Modal>
  );
};

export default ContentMasterSubscriptionInsufficientModal;
